import React, {useState} from "react";
import { Box, Column, Columns, Table, Title } from "@allxsmith/bestax-bulma";
import Calendar from "./Calendar";
import {formatDate, readableDate, toDate} from "../../../utils";
import LoadingSpinner from "../../Utils/Spinner";


export default function FitterHours({job, data, loaded, startInput, endInput, startDate, endDate, selectedDate, setSelectedDate}){
    const [showInfo, setShowInfo] = useState(false);

    const onInfoClick = date => {
        setShowInfo(true);
        setSelectedDate(formatDate(date));
    }

    // we need someway of displaying all the calendars needed from the start date to the end date
    // some fuc that can get the number of months between 2 dates
    const getMonthsDiffBetweenDates = (dateInitial, dateFinal) => {
        return Math.max(
            (dateFinal.getFullYear() - dateInitial.getFullYear()) * 12 + (dateFinal.getMonth() - dateInitial.getMonth()),
            0
        );
    }

    const getCalendarCalls = () =>{
        let runs;
        let passedStart;
        let passedEnd;
        if(startDate){
             passedStart = toDate(startDate);
        }
        else{
            // the start is required for any amount of calls (even 1) so to stop errors this should have a default
            passedStart = new Date();
        }
        if(endDate){
            passedEnd = toDate(endDate);
        }
        // If the start date is the 31st but the next month only has 30 days it will skip that month due to us adding 1 month
        // set to start of whatever month is passed so it always generates the correct months
        passedStart.setDate(1);
        passedEnd.setDate(1);

        if(startDate && endDate) {
            runs = getMonthsDiffBetweenDates(passedStart, passedEnd) +1; // needs to be inclusive of both start and end
            // When the start date is the last date of a month it appears to skip the next month but still create the correct amount of calendars
            // E.G. If start date = 31/03/26 and end date = 04/06/26 April is skipped and July is generated instead
        }
        else{
            // only run for start month
            runs = 1;
        }
        let cols = []
        for(let i=0; i<runs; i++){
            cols.push(
                <Column>
                    <Calendar year={passedStart.getFullYear()} month={passedStart.getMonth()+1} onInfoClick={onInfoClick} startThreshold={toDate(startDate)} endThreshold={toDate(endDate)}/>
                </Column>
            )
            passedStart.setMonth(passedStart.getMonth() + 1)
        }
        return cols
    }

    return (
        <Columns isMultiline>
            <Column></Column>
            <Column>
                <Box>
                    <Columns isMultiline>
                        {startInput}
                        {endInput}
                    </Columns>
                    {/*<Columns>*/}
                    {/*    <Columns.Column>*/}
                    {/*        <Calendar year={getYear(startDate)} month={getMonth(startDate)}/>*/}
                    {/*    </Columns.Column>*/}
                    {/*</Columns>*/}
                    <Columns isMultiline>
                        {getCalendarCalls().map(col => col)}
                    </Columns>
                </Box>
            </Column>
            <Column>
                {showInfo ? (loaded ?
                    <Box>
                        <Columns isMultiline>
                            <Column>
                                <Title className={"App"}>{readableDate(selectedDate)}</Title>
                            </Column>
                        </Columns>
                        <Columns isMultiline>
                            <Column>
                                <Table className={"table-center"} isBordered>
                                    <thead>
                                        <tr>
                                            <th>Fitter</th>
                                            <th>Total Estimated Hours</th>
                                            <th>Total Jobs</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedDate && data[selectedDate].map(fitterValue => (
                                            <tr>
                                                <td>{fitterValue.fitter.name}</td>
                                                <td>{fitterValue.total_hours}</td>
                                                <td>{fitterValue.total_jobs}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Column>
                        </Columns>
                    </Box> :  <LoadingSpinner/>) : <div></div>
                }
            </Column>
            <Column></Column>
        </Columns>
    );


}